import { axiosInstance } from './axiosInstance';
import type {
  AppNotification,
  GetNotificationsParams,
  UnreadCountResponse,
  MarkAllReadResponse,
  PagedApiResponse,
} from '../shared/types';

/**
  Fetch notifications for the logged in user
  GET /api/notifications?unreadOnly=false&page=0&size=20
 */
export async function getNotifications(params?: GetNotificationsParams): Promise<AppNotification[]> {
  const queryParams: Record<string, string | number | boolean> = {
    unreadOnly: params?.unreadOnly ?? false,
    page: params?.page ?? 0,
    size: params?.size ?? 20,
  };

  const response = await axiosInstance.get<PagedApiResponse<AppNotification> | AppNotification[]>('/notifications', {
    params: queryParams,
  });

  if (Array.isArray(response.data)) {
    return response.data;
  }

  if (response.data && Array.isArray(response.data.content)) {
    return response.data.content;
  }

  return [];
}

/**
  Fetch count of unread notifications
  GET /api/notifications/unread-count
 */
export async function getUnreadCount(): Promise<UnreadCountResponse> {
  const response = await axiosInstance.get<UnreadCountResponse | number>('/notifications/unread-count');
  if (typeof response.data === 'number') {
    return { count: response.data };
  }
  return { count: response.data?.count ?? 0 };
}

/**
  Mark a single notification as read
  PATCH /api/notifications/{id}/read
 */
export async function markNotificationAsRead(id: string): Promise<AppNotification | null> {
  const response = await axiosInstance.patch<AppNotification>(`/notifications/${id}/read`);
  return response.data;
}

/**
  Mark all notifications as read for current user
  POST /api/notifications/read-all
 */
export async function markAllNotificationsAsRead(): Promise<MarkAllReadResponse> {
  const response = await axiosInstance.post<MarkAllReadResponse>('/notifications/read-all');
  return response.data ?? { updated: 0 };
}
